module.exports = __webpack_public_path__ + "static/media/Status.2e1df8ca.svg";